import {
  EnvironmentProviders,
  ErrorHandler,
  inject,
  makeEnvironmentProviders,
  provideEnvironmentInitializer,
} from '@angular/core';

import { GlobalErrorHandlerService } from '@core/shared/util';
import { AppInsightsService, provideAppInsightsDataAccess } from '@mp/shared/app-insights/data-access';

export function provideAppInsightsFeature(): EnvironmentProviders[] {
  return [
    provideAppInsightsDataAccess(),
    makeEnvironmentProviders([
      {
        provide: GlobalErrorHandlerService,
        useFactory: (errorHandler: ErrorHandler) => {
          return errorHandler instanceof GlobalErrorHandlerService ? errorHandler : null;
        },
        deps: [ErrorHandler],
      },
      provideEnvironmentInitializer(() => {
        const appInsightsService: AppInsightsService = inject(AppInsightsService);
        // Initialize the App Insights upon app start
        appInsightsService.initializeAppInsights();
      }),
    ]),
  ];
}
